<template>
  <div class="button" :class="compCssClasses">
    <slot :label="label">{{ label }}</slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      validator(val) {
        const isValid = ['R', 'E'].indexOf(val) != -1
        return isValid
      },
    },
    translucid: { type: Boolean, default: false },
    color: { type: String, required: true },
    label: { type: String },
  },
  computed: {
    compCssClasses() {
      const cssClasses = []

      switch (this.type) {
        case 'R':
          cssClasses.push('rounded')
          break
        case 'E':
          cssClasses.push('ellips')
          break
        default:
          break
      }

      switch (this.color) {
        case 'Y':
          cssClasses.push('yellow')
          break
        case 'B':
          cssClasses.push('blue')
          break
        case 'DB':
          cssClasses.push('dark-blue')
          break
        default:
          break
      }

      if (this.translucid) cssClasses.push('translucid')

      return cssClasses
    },
  },
  methods: {
    handleClick() {},
  },
}
</script>

<style lang="scss" scoped>
.button {
  display: inline-block;
  padding: 10px;
  cursor: pointer;
}
.rounded {
  border-radius: 4px;
}
.ellips {
  border-radius: 100px;
}

.yellow {
  background-color: #facb0a;
}
.blue {
  background-color: #113759;
}
.translucid {
  opacity: 0.7;
}
</style>
